// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmAutoTopUp-Dialog_cls1__IlliN","cls2":"ConfirmAutoTopUp-Dialog_cls2__QGHfh ConfirmAutoTopUp-Dialog_cls1__IlliN"};